<template>
  <page-section>
    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="['dynamic_promotions_sync']"
    />
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
export default {
  name: 'DynamicOverview',
  components: { IntegrationTasksTable, PageSection },
  props: {
    model: {
      required: false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/dynamicpromotions/DynamicOverview.vue